import dashboard from "Language/dashboard";
import editRoles from "Language/editRoles";
import reservation from "Language/reservation";
import editPictures from "Language/editPictures";
import reviewsRespond from "Language/reviewsRespond";
import daysMonths from "Language/daysMonths";
import basicInformation from "Language/basicInformation";
import editLocation from "Language/editLocation";
import editMenu from "Language/editMenu";
import inputLabels from "Language/inputLabels";
import calendar from "Language/calendar";
import admin from "Language/admin";
import services from "Language/services";
import linkSocial from "Language/linkSocial";
import legalInformation from "Language/legalInformation";
import statisticsGeneral from "Language/statisticsGeneral";
import statisticsCheckins from "Language/statisticsCheckins";
import statisticsAcquisition from "Language/statisticsAcquisition";
import foodiesStatistics from "Language/foodiesStatistics";
import editProfile from "Language/editProfile";
import login from "Language/login";
import changesDates from "Language/changesDates";
import widget from "Language/widget";

const resources = {
  lng: "it",
  resources: {
    en: {
      translation: {
        dashboard: dashboard.en.translation,
        editRoles: editRoles.en.translation,
        reservation: reservation.en.translation,
        editPictures: editPictures.en.translation,
        reviewsRespond: reviewsRespond.en.translation,
        daysMonths: daysMonths.en.translation,
        basicInformation: basicInformation.en.translation,
        editLocation: editLocation.en.translation,
        inputLabels: inputLabels.en.translation,
        editMenu: editMenu.en.translation,
        calendar: calendar.en.translation,
        services: services.en.translation,
        linkSocial: linkSocial.en.translation,
        legalInformation: legalInformation.en.translation,
        statisticsGeneral: statisticsGeneral.en.translation,
        statisticsCheckins: statisticsCheckins.en.translation,
        statisticsAcquisition: statisticsAcquisition.en.translation,
        foodiesStatistics: foodiesStatistics.en.translation,
        editProfile: editProfile.en.translation,
        admin: admin.en.translation,
        login: login.en.translation,
        changesDates: changesDates.en.translation,
        widget: widget.en.translation,
        ciao: "hello",
        yes: "Yes",
        no: "No",
        of: "Of",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        change_language: "Change language",
        language_it: "Italiano",
        language_en: "English",
        menu: "Menu",
        location: "Location",
        service: "Service",
        price: "Price",
        day: "Day",
        month: "Month",
        not_reviewed: "Not reviewed",
        level_poor: "Very Poor",
        level_low: "Low",
        level_plenty: "Average",
        level_good: "Good",
        level_excellent: "Superb",
        level_outstanding: "Outstanding",
        poor: "Very Poor",
        low: "Low",
        plenty: "Average",
        good: "Good",
        excellent: "Superb",
        outstanding: "Outstanding",
        save_success_title: "Good job!",
        show_more: "Show more",
        analysis_period: "Analysis period",
        save_success_text: "Your changes have been saved successfully",
        save_error_title: "Oops, something went wrong!",
        save_error_text:
          "An error occurred, please wait a few moments and try again. If the problem persists, contact us at support@foodiestrip.com",
        popup_not_authorized_title: "Oops, something went wrong!",
        popup_not_authorized_text:
          "It looks like you don't have permission to manage this page, please contact us at support@foodiestrip.com",
        editing_other_section_title: "Oops!",
        editing_other_section_text:
          "You are editing another section. Make sure you have finished before moving on to the next one.",
        view_plans: "View plans",
        service_not_paid_stats:
          "Analyze your target through our advanced statistics! Discover the Essential, Essential plus and Premium plans in the dedicated section."
      }
    },
    it: {
      translation: {
        dashboard: dashboard.it.translation,
        editRoles: editRoles.it.translation,
        reservation: reservation.it.translation,
        editPictures: editPictures.it.translation,
        reviewsRespond: reviewsRespond.it.translation,
        daysMonths: daysMonths.it.translation,
        basicInformation: basicInformation.it.translation,
        editLocation: editLocation.it.translation,
        inputLabels: inputLabels.it.translation,
        editMenu: editMenu.it.translation,
        calendar: calendar.it.translation,
        services: services.it.translation,
        linkSocial: linkSocial.it.translation,
        legalInformation: legalInformation.it.translation,
        statisticsGeneral: statisticsGeneral.it.translation,
        statisticsCheckins: statisticsCheckins.it.translation,
        statisticsAcquisition: statisticsAcquisition.it.translation,
        foodiesStatistics: foodiesStatistics.it.translation,
        editProfile: editProfile.it.translation,
        admin: admin.it.translation,
        login: login.it.translation,
        changesDates: changesDates.it.translation,
        widget: widget.it.translation,
        ciao: "ciao",
        yes: "Si",
        no: "No",
        of: "di",
        save: "Salva",
        cancel: "Annulla",
        edit: "Modifica",
        delete: "Cancella",
        change_language: "Cambia lingua",
        language_it: "Italiano",
        language_en: "English",
        menu: "Menu",
        location: "Location",
        service: "Servizio",
        price: "Prezzo",
        day: "Giorno",
        month: "Mese",
        not_reviewed: "Non recensito",
        level_poor: "Molto Scarso",
        level_low: "Mediocre",
        level_plenty: "Sufficiente",
        level_good: "Buono",
        level_excellent: "Ottimo",
        level_outstanding: "Eccellente",
        poor: "Molto Scarso",
        low: "Mediocre",
        plenty: "Sufficiente",
        good: "Buono",
        excellent: "Ottimo",
        outstanding: "Eccellente",
        save_success_title: "Ottimo lavoro!",
        show_more: "Mostra altro",
        analysis_period: "Periodo di analisi",
        save_success_text: "Le tue modifiche sono state salvate con successo",
        save_error_title: "Ops, qualcosa è andato storto!",
        save_error_text:
          "Si è verificato un problema, riprova tra poco. Se il problema persiste scrivici a support@foodiestrip.com",
        popup_not_authorized_title: "Ops, qualcosa è andato storto!",
        popup_not_authorized_text:
          "Sembra che tu non abbia i permessi per gestire questa attività, per favore contattaci a support@foodiestrip.com",
        editing_other_section_title: "Attenzione!",
        editing_other_section_text:
          "Stai già modificando un'altra sezione. Assicurati di aver terminato prima di passare alla prossima.",
        view_plans: "Vai ai piani",
        service_not_paid_stats:
          "Analizza il tuo target attraverso le statistiche avanzate di foodiestrip! Scopri i piani Essential, Essential plus e Premium nella sezione dedicata."
      }
    }
  }
};

export default resources;
